<template>
  <div>
    <v-layout wrap>
      <v-flex >
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="accountId"
            :search-url="searchUrl"
            create-url="/babiAccountClass/save"
            delete-url="/babiAccountClass/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            :acceptDelete="false"
            :acceptView="true"
            @viewItem="viewItem"
            @setLastSearchValues="setLastSearchValues"
            :lastSearchValues="lastSearchValues"
            orderBy="asc,desc"
            :acceptBack="1001"

        >
        </c-search-form>
        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/admin/babi_account_class/AccountDetailCreate";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: null,
      formCreateName: "Thêm mới học sinh",
      category: null,
      visibleCreateDialog: false,
      searchUrl:null,
      classNameSearch:null,
      lastSearchValues: {},
      timeReload: 0,
      hiddenFields: {
        typeId: "0",
      },
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "3%",
          sortable: false,
          headerStyle: "text-align:center",
        },
        {
          value: 'accountId',
          text: 'AccountID',
          sortable: false,
          search: true,
          width: "4%",
          headerStyle: "text-align:center",
        },
        {
          value: 'phoneNumber',
          text: 'Phone',
          sortable: false,
          search: true,
          width: "4%",
          headerStyle: "text-align:center",
        },
        {
          value: 'classId',
          text: 'Tên lớp',
          width: "15%",
          sortable: false,
          search: false,
          headerStyle: "text-align:center",
          type: "select",
          name: "classId",
          items: [],
          itemText: "className",
          itemValue: "classId",
        },
        {
          value: 'accountName',
          text: 'Họ tên',
          sortable: false,
          search: true,
          width: "9%",
          headerStyle: "text-align:center",
        },
        {
          value: 'birthYear',
          text: 'Năm sinh',
          sortable: false,
          search: true,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'zaloPH',
          text: 'Zalo phụ huynh',
          sortable: false,
          search: true,
          width: "8%",
          headerStyle: "text-align:center",
        },
        {
          value: 'classCurrentUnit',
          text: 'Unit chuẩn',
          sortable: false,
          search: true,
          width: "4%",
          headerStyle: "text-align:center",
        },
        {
          value: 'classCurrentLevel',
          text: 'Level chuẩn',
          sortable: false,
          search: true,
          width: "4%",
          headerStyle: "text-align:center",
        },
        {
          value: 'unitCurrent',
          text: 'Unit hiện tại',
          sortable: false,
          search: true,
          width: "4%",
          headerStyle: "text-align:center",
        },
        {
          value: 'levelCurrent',
          text: 'Level hiện tại',
          sortable: false,
          search: true,
          width: "4%",
          headerStyle: "text-align:center",
        },
        {
          value: 'unitDeviate',
          text: 'Unit lệch',
          search: true,
          sortable: false,
          width: "4%",
          headerStyle: "text-align:center",
        },

        {
          value: 'missionNumber',
          text: 'Số nhiệm vụ đã làm',
          sortable: false,
          search: true,
          width: "4%",
          headerStyle: "text-align:center",
        },
        {
          value: 'liveclassNumber',
          text: 'Live class',
          sortable: false,
          search: true,
          width: "4%",
          headerStyle: "text-align:center",
        },
        {
          value: 'categoryNumber',
          text: 'Category',
          sortable: false,
          search: true,
          width: "4%",
          headerStyle: "text-align:center",
        },
        {
          value: 'middleTest',
          text: 'Midterm test',
          sortable: false,
          search: true,
          width: "4%",
          headerStyle: "text-align:center",
        },
        {
          value: 'finalTest',
          text: 'Final test',
          sortable: false,
          search: true,
          width: "4%",
          headerStyle: "text-align:center",
        },
        {
          value: "action",
          text: "lang.common.actions",
          sortable: false,
          compound: true,
          width: "13%",
          headerStyle: "text-align:center",
        },
      ],
    };
  },

  created() {
    this.searchUrl = "/babiAccountClass/search/" + this.$route.params.id + "?sortField=status,accountId&";
    axios.post(
        process.env.VUE_APP_API_URL + "/babiClass/listAllName", {programId: this.$route.params.id}
    )
        .then(
            (data) => {
              if (data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                  if (data[i].classId == this.$route.params.id) {
                    this.formName = "Danh sách học sinh lớp " + data[i].className;
                    this.classNameSearch = data[i].className;
                  }
                }
              }
              let itemFields = this.fields.filter(function (e) {

                return e.name == "classId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );
  },

  methods: {

    openCreateDialog: function (item = null) {
      if (item == null) {
        this.formCreateName = 'BabiClass Thêm mới học sinh';
      } else {
        this.category = item;
        this.formCreateName = 'BabiClass Cập nhật học sinh';
        this.visibleCreateDialog = true;
      }
    },
    closeCreateDialog: function () {
      this.category = null;
      this.visibleCreateDialog = false;
      this.timeReload = Math.floor(Math.random() * 100);
    },

    setLastSearchValues: function (values) {
      this.lastSearchValues = Object.assign(this.lastSearchValues, values);
    },
    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
    viewItem: function (item) {
      this.$router.push({
        path: '/babiAccountDetailClass/view/' + item.accountId,
        query: this.createParamLastSearch(this.lastSearchValues)
      });
    },
  },

  destroyed() {
  },
};
</script>
